var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vlInlineBlock vlWFull",attrs:{"href":_vm.$_prop('href')},domProps:{"innerHTML":_vm._s(_vm.$_prop('html'))}})}
var staticRenderFns = []

export { render, staticRenderFns }